export default __webpack_public_path__ + "static/Background-77296dfdbf24960926b4bc560671ccb9.png";